module.exports = __webpack_public_path__ + "img/yage.5fdc4248.png";